import { render, staticRenderFns } from "./seller.vue?vue&type=template&id=01dae56b&scoped=true"
import script from "./seller.vue?vue&type=script&lang=js"
export * from "./seller.vue?vue&type=script&lang=js"
import style0 from "./seller.vue?vue&type=style&index=0&id=01dae56b&prod&lang=scss&scoped=true"
import style1 from "./seller.vue?vue&type=style&index=1&id=01dae56b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dae56b",
  null
  
)

export default component.exports